export const Loading = () => {
  return (
    <div class='flex-column loading-container'>
      <div class='loading-spinner'></div>
      <p>Loading ...</p>
    </div>
  );
}